import { getViewportWidth } from "./getViewportWidth";

describe("getViewportWidth", () => {
    it("returns the viewport width", () => {
        //@ts-ignore
        global.window = Object.create(window);
        expect(getViewportWidth()).toBe(1366);
    });
});
